var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.64583 11.8542H2.6849L9.8125 4.72656L8.77344 3.6875L1.64583 10.8151V11.8542ZM0.1875 13.3125V10.2135L9.8125 0.606771C9.95833 0.47309 10.1194 0.369792 10.2956 0.296875C10.4718 0.223958 10.6571 0.1875 10.8516 0.1875C11.046 0.1875 11.2344 0.223958 11.4167 0.296875C11.599 0.369792 11.7569 0.479167 11.8906 0.625L12.8932 1.64583C13.0391 1.77951 13.1454 1.9375 13.2122 2.11979C13.2791 2.30208 13.3125 2.48438 13.3125 2.66667C13.3125 2.86111 13.2791 3.04644 13.2122 3.22266C13.1454 3.39887 13.0391 3.5599 12.8932 3.70573L3.28646 13.3125H0.1875ZM9.28385 4.21615L8.77344 3.6875L9.8125 4.72656L9.28385 4.21615Z",
    fill: "#1D1B20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.55329f97cf6347ec4a002ab5e605a6c0.svg";
export { ForwardRef as ReactComponent };